export enum PageTypeEnum {
  Shop = 'Shop',
}
